import React from "react"
import PropTypes from "prop-types"
import "./sky-marketing-2.scss"
import Button from "../shared/button/text-button"
import router from "../../images/splashScreens/sky-router.png"
import signal from "images/splashScreens/sky-wifi.jpeg"
import wrench from "images/splashScreens/sky-wrench.jpeg"
import devices from "images/splashScreens/sky-devices.jpeg"
import lightning from "images/splashScreens/sky-lightning.png"

const MarketingSky2 = ({ handleButtonClick, handleBackButtonClick }) => (
  <div className="marketing-page">
    <div className="marketing-page--info">
      <div className="marketing-page--info--image">
        <img src={router} alt="4G" />
      </div>
      <div className="marketing-page--info--text">
        <h1 className="marketing-page--info--text--black-heading">
          Get totally unlimited downloads, line rental, Sky Talk Anytime and our
          latest Sky Hub included with all our Sky Broadband deals.
        </h1>
      </div>
    </div>
    <div className="marketing-page--extras marketing-page--sky sky-row">
      <div className="marketing-page--extras--container large">
        <h3>
          Add Sky Boost to any of our Broadband packages and you’ll get
          guaranteed WiFi in every room of your home.
        </h3>
        <div className="marketing-page--extras--container--row">
          <div className="">
            <img src={signal} alt="" />
            <p>
              We’ll guarantee at least 3Mbps WiFi in every room of your home, or
              we will give you your money back.
            </p>
          </div>
          <div>
            <img src={wrench} alt="" />
            <p>
              If your speeds fall lower than 3Mbps, we’ll send you a Sky
              Broadband booster or our Tech team can visit to check your set-up.
            </p>
          </div>
          <div>
            <img src={devices} alt="" />
            <p>
              Manage your devices in your home and enjoy peace of mind that your
              family is using the internet safely.
            </p>
          </div>
        </div>
      </div>
      <div className="marketing-page--extras--container small">
        <h3>Sky Broadband Ultrafast</h3>
        <div>
          <img src={lightning} alt="" />
          <p>
            With the increasing number of connected and WiFi-enabled devices in
            our homes, ranging from smart TVs, speakers, virtual assistants and
            even smart fridges, faster broadband is essential to keep up.
          </p>
        </div>
      </div>
    </div>

    <div className="marketing-button-container">
      <Button text="Back" onClick={handleBackButtonClick} />
      <Button text="Continue" onClick={handleButtonClick} />
    </div>
  </div>
)

MarketingSky2.propTypes = {
  handleButtonClick: PropTypes.func.isRequired,
  handleBackButtonClick: PropTypes.func.isRequired
}

export default MarketingSky2
